import React from "react"
import {RefTable, DefaultProps} from "../RefTable"

export const AutoActiveFeeClasses = (props)=><RefTable {...props}/>;

AutoActiveFeeClasses.defaultProps = {
    ...DefaultProps,
    title: "Auto Active Fee Classes",
    tableSchema: "fee_classes_auto_active",
    tableName: "fee_classes_auto_active",
    edit: true,
}
